export default __webpack_public_path__ + "static/media/DSC_0509.309c6e45.webp";